import React from "react";
import { motion } from "framer-motion";
import { Search, GitCompareArrows, MessageCircle } from "lucide-react";

const steps = [
  {
    icon: Search,
    number: "01",
    title: "Search",
    description:
      "Browse nursing homes by county, filter by amenities, price, and care type to find the best match.",
  },
  {
    icon: GitCompareArrows,
    number: "02",
    title: "Compare",
    description:
      "Use our side-by-side comparison tool to evaluate facilities on what matters most to your family.",
  },
  {
    icon: MessageCircle,
    number: "03",
    title: "Connect",
    description:
      "Chat with our Care Advisor for free guidance, or enquire directly with nursing homes.",
  },
];

export default function HowItWorks() {
  return (
    <section className="py-20 bg-background">
      <div className="container">
        <div className="text-center mb-14">
          <h2 className="section-title mb-4">
            Three simple steps to <span className="text-primary">peace of mind</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            We've simplified the process so you can focus on what matters — your family.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {steps.map((step, i) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              className="relative text-center group"
            >
              {/* Connector line */}
              {i < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-px border-t-2 border-dashed border-border" />
              )}

              <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-accent mb-5 group-hover:shadow-lg group-hover:shadow-primary/10 transition-shadow duration-300">
                <step.icon className="h-8 w-8 text-primary" />
              </div>
              <span className="block text-xs font-mono text-muted-foreground mb-2 tracking-widest">
                STEP {step.number}
              </span>
              <h3 className="text-xl font-semibold text-foreground mb-3 font-lora">
                {step.title}
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed max-w-xs mx-auto">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
